import React, { useState, useEffect } from "react";
import TopNavBar from "./TopNavBar";
import { Sparkles, MessageCircleMore, Layers } from "lucide-react";
import TopperIconBadge from "./TopperIconBadge";
import AwardBadgeIcon from "./AwardBadgeIcon";
import BadgeLike from "./BadgeLike";
import { projectURL } from './utils/mockdata';

const Gamification = (props) => {
  const [mostActivePerson, setMostActivePerson] = useState(null);
  const [maxPostCreator, setMaxPostCreator] = useState(null);
  const [maxCommentCreator, setMaxCommentCreator] = useState(null);
  const [maxLikeCreator, setMaxLikeCreator] = useState(null);
  const [maxRepliesCreator, setMaxRepliesCreator] = useState(null);
  const [maxFriends, setMaxFriends] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [mostActiveRes, maxPostRes, maxCommentRes, maxLikeRes, maxRepliesRes, maxFriendsRes] = await Promise.all([
          fetch(projectURL + 'dashboard/most-active-person').then(res => res.json()),
          fetch(projectURL + 'dashboard/max-post-creator-user').then(res => res.json()),
          fetch(projectURL + 'dashboard/max-comment-creator-user').then(res => res.json()),
          fetch(projectURL + 'dashboard/max-like-creator-user').then(res => res.json()),
          fetch(projectURL + 'dashboard/max-replies-creator-user').then(res => res.json()),
          fetch(projectURL + 'dashboard/max-friends-user').then(res => res.json())
        ]);
        setMostActivePerson(mostActiveRes[0]);
        setMaxPostCreator(maxPostRes[0]);
        setMaxCommentCreator(maxCommentRes[0]);
        setMaxLikeCreator(maxLikeRes[0]);
        setMaxRepliesCreator(maxRepliesRes[0]);
        setMaxFriends(maxFriendsRes[0]);
      } catch (error) {
        console.error('Error fetching dashboard data', error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="min-h-full">
      <TopNavBar />
      <main>
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-gray-900"> LeaderBoard </h1>
          </div>

          <div className="mx-auto mt-8 grid max-w-md grid-cols-1 gap-6 sm:grid-cols-2 lg:max-w-none lg:grid-cols-3">

            <div className="grid grid-cols-1 ">
              <div className="col-span-1 flex flex-col items-center justify-center p-2 bg-white rounded-lg shadow-md">
                <div className="text-lg font-bold text-gray-800">
                  Most Active Person
                  <TopperIconBadge className="mx-auto mt-4 h-8 w-8 text-green-500" />
                </div>
                <p className="mt-2 text-gray-600 flex items-center justify-center">
                  {mostActivePerson ? mostActivePerson.username : 'Loading...'}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 ">
              <div className="col-span-1 flex flex-col items-center justify-center p-2 bg-white rounded-lg shadow-md">
                <div className="text-lg font-bold text-gray-800">
                  Max Post Generator
                  <Layers className="mx-auto mt-4 h-8 w-8 text-green-500" />
                </div>
                <p className="mt-2 text-gray-600 flex items-center justify-center">
                  {maxPostCreator ? maxPostCreator.username : 'Loading...'}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 ">
              <div className="col-span-1 flex flex-col items-center justify-center p-2 bg-white rounded-lg shadow-md">
                <div className="text-lg font-bold text-gray-800">
                  Max Commenter
                  <MessageCircleMore className="mx-auto mt-4 h-8 w-8 text-yellow-500" />

                </div>
                <p className="mt-2 text-gray-600 flex items-center justify-center">
                  {maxCommentCreator ? maxCommentCreator.username : 'Loading...'}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 ">
              <div className="col-span-1 flex flex-col items-center justify-center p-2 bg-white rounded-lg shadow-md">
                <div className="text-lg font-bold text-gray-800">
                  Max Like Giver
                  <BadgeLike className="mx-auto mt-4 h-8 w-8 text-purple-500" />
                </div>
                <p className="mt-2 text-gray-600 flex items-center justify-center">
                  {maxLikeCreator ? maxLikeCreator.username : 'Loading...'}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 ">
              <div className="col-span-1 flex flex-col items-center justify-center p-2 bg-white rounded-lg shadow-md">
                <div className="text-lg font-bold text-gray-800">
                  Max Replier Person
                  <Sparkles className="mx-auto mt-4 h-8 w-8 text-pink-500" />

                </div>
                <p className="mt-2 text-gray-600 flex items-center justify-center">
                  {maxRepliesCreator ? maxRepliesCreator.username : 'Loading...'}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 ">
              <div className="col-span-1 flex flex-col items-center justify-center p-2 bg-white rounded-lg shadow-md">
                <div className="text-lg font-bold text-gray-800">
                  Max Friend Connections
                  <AwardBadgeIcon className="mx-auto mt-4 h-8 w-8 text-red-500" />
                </div>
                <p className="mt-2 text-gray-600 flex items-center justify-center">
                  {maxFriends ? maxFriends.username : 'Loading...'}
                </p>
              </div>
            </div>

          </div>

        </div>
      </main>
    </div>
  );
}

export default Gamification;